import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManualOrderService } from 'src/app/core/services/api-services/manual-order.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormService } from 'src/app/core/services/form.service';

@Component({
  selector: 'app-add-drug-modal',
  templateUrl: './add-drug-modal.component.html',
  styleUrls: ['./add-drug-modal.component.scss']
})
export class AddDrugModalComponent implements OnInit {

  buzzerCodeDisabled: boolean = false;
  submitted = false;
  drugForm!: FormGroup;
  countryList: any[] = [];
  statlist: any[] = [];
  userId: any = '';
  positiveNumberRegex = /^[0-9]\d*$/;

  constructor(private fb: FormBuilder,
    private manualService: ManualOrderService,
    public dialogRef: MatDialogRef<AddDrugModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastrService: ToastrService,public formService: FormService,) { }

  ngOnInit(): void {
    this.initializeDrugform();
  }

  onClose() {
    this.dialogRef.close();
  }

  initializeDrugform() {
    this.drugForm = this.fb.group({
      name: ['', Validators.required],
      din: ['',Validators.compose([Validators.required,Validators.pattern(this.positiveNumberRegex),Validators.min(1)]),],
      durg_from: ['', Validators.required],
      strength: ['', Validators.required],
      server_location: [this.formService.selectedLocation.value]
    });
  }

  submitForm() {
    this.submitted = true;

    //console.log(this.drugForm.value);
    if (this.drugForm.valid) {
      this.manualService.CreateDrug(this.drugForm.value).subscribe(
        (res) => {
          if (res?.body?.success) {
            this.dialogRef.close(this.drugForm.value);
            //this.drugForm.reset();
            this.toastrService.success(res?.body?.message);
          }
        },
        (error) => {
          console.error('Error adding drug:', error);
        }
      );
    } else {
      console.error('Form is invalid');
      // You can handle invalid form submission here, such as displaying error messages
    }
  }
}
